import React from "react";

export interface MetricCardProps {
  icon: React.ReactNode;
  title: string;
  value: number;
  subtitle: string;
  color?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({ 
  icon, 
  title, 
  value, 
  subtitle, 
  color = "#2F80ED" 
}) => (
  <div className="metric-card">
    <div className="metric-card__icon" style={{ color }}>
      {icon}
    </div>
    <div className="metric-card__content">
      <div className="metric-card__value">{value}</div>
      <div className="metric-card__subtitle">{title}</div>
    </div>
  </div>
);

export default MetricCard;
